import { FC } from 'react';

export const KeyboardArrowUp: FC = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
  </svg>
);

export default KeyboardArrowUp;
